


import React, { useState } from 'react';
import { Phone, Check } from 'lucide-react';
import Button from './ui/Button';

const ClinicLogo = () => (
  <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-lg flex items-center justify-center font-bold text-white text-xl shadow-md">
    RH
  </div>
);

const SecureMessagePortalPage = ({
  clinicName,
  clinicSubtitle,
  senderName,
  messageSentTimestamp,
  messageBody,
  clinicPhoneNumber,
  linkExpiryDate,
  poweredByText
}) => {
  const [acknowledged, setAcknowledged] = useState(false);

  const handleAcknowledge = () => {
    setAcknowledged(true);
    console.log('Message Acknowledged by patient.');
  };

  const handleCall = () => {
    alert(`Calling ${clinicPhoneNumber}...`);
  };

  return (
    <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm max-w-xl mx-auto mt-12 font-inter">
      <div className="px-4 py-5 sm:px-6 flex items-center gap-4">
        <ClinicLogo />
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-gray-800 tracking-tight">{clinicName}</h1>
          <p className="text-xs sm:text-sm text-gray-500 mt-0.5">{clinicSubtitle}</p>
        </div>
      </div>
      <div className="px-4 py-5 sm:p-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-700 mb-3 text-center tracking-tight">Your Secure Message</h2>
        <p className="text-sm text-gray-600 mb-1.5 text-center">
          From: <strong className="text-gray-800">{senderName}</strong>
        </p>
        <p className="text-xs text-gray-400 mb-6 text-center">
          Sent: {messageSentTimestamp}
        </p>
        <div className="bg-gray-50 p-5 sm:p-6 rounded-xl border border-gray-200 text-base text-slate-700 leading-relaxed whitespace-pre-wrap shadow-inner">
          {messageBody}
        </div>
        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <Button
            onClick={handleCall}
            variant="secondary"
            size="md"
            className="flex-1 py-2.5 px-4 flex items-center justify-center gap-2 active:translate-y-px"
          >
            <Phone size={18} />
            Call {clinicPhoneNumber}
          </Button>
          <Button
            onClick={handleAcknowledge}
            disabled={acknowledged}
            variant={acknowledged ? 'danger' : 'primary'}
            size="md"
            className="flex-1 py-2.5 px-4 flex items-center justify-center gap-2 active:translate-y-px"
          >
            <Check size={20} />
            {acknowledged ? 'Acknowledged' : 'Acknowledge Message'}
          </Button>
        </div>
      </div>
      <div className="px-4 py-4 sm:px-6 text-center text-xs text-gray-500">
        <p>This message is secure. Please do not share this link.</p>
        <p>This link will expire on {linkExpiryDate}.</p>
        <p className="text-[11px] text-gray-400 mt-1.5">{poweredByText}</p>
      </div>
    </div>
  );
};

export default SecureMessagePortalPage;